import * as Actions from 'app/store/actions';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

function useReduxLoading(loading = false) {
  const dispatch = useDispatch();

  const ref = useRef(loading);

  useEffect(() => {
    ref.current = loading;

    if (loading) {
      dispatch(Actions.openBackdrop());
    } else {
      dispatch(Actions.closeBackdrop());
    }
  }, [loading, dispatch]);

  const dispatchCloseBackdrop = () => dispatch(Actions.closeBackdrop());

  return [ref.current, dispatchCloseBackdrop];
}

export default useReduxLoading;
